import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 24px;
  flex-direction: column;
  gap: 32px;
`;

export const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TableHeader = styled.div`
  width: 100%;
  padding: 12px;
  background-color: light-dark(#f8f9fa, var(--mantine-color-dark-6));
  border-radius: 8px 8px 0px 0px;
  border-top: 1px solid var(--Gray-Gray-1, light-dark(#f1f3f5, var(--mantine-color-dark-6)));
  border-bottom: 1px solid var(--Gray-Gray-1, light-dark(#f1f3f5, var(--mantine-color-dark-6)));
  border-left: 1px solid var(--Gray-Gray-1, light-dark(#f1f3f5, var(--mantine-color-dark-6)));
`;

export const TableBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TableItem = styled.div`
  width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  height: 76px;
  border-right: 1px solid var(--Gray-Gray-1, light-dark(#f1f3f5, var(--mantine-color-dark-6)));
  border-bottom: 1px solid var(--Gray-Gray-1, light-dark(#f1f3f5, var(--mantine-color-dark-6)));
  border-left: 1px solid var(--Gray-Gray-1, light-dark(#f1f3f5, var(--mantine-color-dark-6)));

  .toggler {
    width: 50%;
    display: flex;
    padding: 18px 12px;

    button {
      display: flex;
      align-items: center;
      height: 50px;
      gap: 8px;
      color: var(--mantine-color-text);
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 140%; /* 19.6px */
    }
  }

  .aifs {
    width: 50%;
    height: 100%;
    padding: 12px 8px;
    // display: flex;
    flex-wrap: wrap;
    color: var(--mantine-color-text);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
    border-left: 1px solid var(--Gray-Gray-1, light-dark(#f1f3f5, var(--mantine-color-dark-6)));

    .names {
      height: 62px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  .aif {
    height: 50px;
    padding: 18px 56px;
    color: var(--mantine-color-text);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  }
`;

export const SpaceBetweenBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  p {
    color: light-dark(#495057, var(--mantine-color-dark-1));
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 19.6px */
  }

  span {
    color: light-dark(#868e96, var(--mantine-color-dark-2));

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 19.6px */
  }
`;

export const ActionBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
`;
